export const SUPPLIER_GSTIN_FILTER =
  "boilerplate/ImsReco/Outward/SUPPLIER_GSTIN_FILTER";
export const RECEIPIENT_GSTIN_FILTER =
  "boilerplate/ImsReco/Outward/RECEIPIENT_GSTIN_FILTER";
export const INUM_FILTER = "boilerplate/ImsReco/Outward/INUM_FILTER";
export const SELECTED_FROM_DATE =
  "boilerplate/ImsReco/Outward/SELECTED_FROM_DATE";
export const SELECTED_TO_DATE = "boilerplate/ImsReco/Outward/SELECTED_TO_DATE";
export const HISTORY_TABLE_DATA =
  "boilerplate/ImsReco/Outward/HISTORY_TABLE_DATA";
export const SUMMARY_TABLE_DATA =
  "boilerplate/ImsReco/Outward/SUMMARY_TABLE_DATA";
export const VIEW_TABLE_DATA = "boilerplate/ImsReco/Outward/VIEW_TABLE_DATA";
export const LOADER_STATUS = "boilerplate/ImsReco/Outward/LOADER_STATUS";
export const SELECTED_HISTORY = "boilerplate/ImsReco/Outward/SELECTED_HISTORY";
export const SELECTED_GSTIN_HISTORY =
  "boilerplate/ImsReco/Outward/SELECTED_GSTIN_HISTORY";
export const CONSOLIDATED_DATA =
  "boilerplate/ImsReco/Outward/CONSOLIDATED_DATA";
export const REJECTED_DATA = "boilerplate/ImsReco/Outward/REJECTED_DATA";

export const TOTAL_PAGES_REJECTED =
  "boilerplate/ImsReco/Outward/TOTAL_PAGES_REJECTED";
export const TOTAL_PAGES_HISTORY =
  "boilerplate/ImsReco/Outward/TOTAL_PAGES_HISTORY";

export const headerColumns = [
  {
    value: "History",
    id: "1",
  },
  {
    value: "Summary",
    id: "2",
  },
  {
    value: "View Rejected",
    id: "3",
  },
];
export const headerColumnsSectionWise = [
  {
    value: "Consolidated",
    id: "1",
  },
  {
    value: "Rejected",
    id: "2",
  },
];
// export const returnType = [
//   {
//     label: "All",
//     value: "select_all",
//     checked: false,
//     children: [
//       {
//         label: "GSTR-1",
//         value: "GSTR-1",
//         checked: false, // 👈 Default selected
//       },
//       {
//         label: "GSTR-1A",
//         value: "GSTR-1A",
//         checked: false,
//       },
//     ],
//   },
// ];

export const returnType = [
  {
    label: "GSTR-1",
    value: "GSTR-1",
    checked: false, // 👈 Default selected
  },
  {
    label: "GSTR-1A",
    value: "GSTR-1A",
    checked: false,
  },
];

export const sectionList = [
  {
    label: "4A, 4B, 6B, 6C - B2B, SEZ, DE Invoices",
    value: "4A, 4B, 6B, 6C - B2B, SEZ, DE Invoices",
  },
  {
    label: "9B-Credit/Debit Notes(Registered)",
    value: "9B-Credit/Debit Notes(Registered)",
  },
  { label: "15-Supplies U/s9(5)", value: "15-Supplies U/s9(5)" },
  { label: "9A-Amended B2B Invoices", value: "9A-Amended B2B Invoices" },
  {
    label: "9C-Amended Credit/Debit Notes(Registered)",
    value: "9C-Amended Credit/Debit Notes(Registered)",
  },
  {
    label: "15A- Amended Supplies U/s 9(5)",
    value: "15A- Amended Supplies U/s 9(5)",
  },
];
